import { get } from '@xmatters/redux/services/httpService';

export const INIT_TRIGGER_FORM_SUCCESS = 'INIT_TRIGGER_FORM_SUCCESS';
export const INIT_TRIGGER_FORM_FAILED = 'INIT_TRIGGER_FORM_FAILED';
export const TRIGGER_FORM_SELECTED = 'TRIGGER_FORM_SELECTED';
export const INIT_TRIGGER_FORM_RESET = 'INIT_TRIGGER_FORM_RESET';

/**
 * Activate an automation form by *formId*
 *
 * @param {{}} options Action Options
 * @param {string} options.triggerFormId The formId (database form id, NOT form uuid)
 * @returns Redux Standard Action
 */
export function selectTriggerForm({ triggerFormId }) {
  return {
    type: TRIGGER_FORM_SELECTED,
    payload: { triggerFormId },
  };
}

/**
 * Activate an automation form by *form identifier* (UUID)
 *
 * @param queryCache The redux query cache, we'll use this to pull data from
 * @returns Redux Thunk that will look up the formId (db Id) then trigger that
 * automation form
 *
 * This is a curried function, so our first call passes the cache and gets back
 * the thunk. The thunk itself can be dispatched (standard redux useDispatch) to
 * trigger a cache lookup. As soon as we have the db ID we trigger the form with
 * the action above.
 */
export const activateTriggerFormUuid = queryCache => uuid => {
  return async dispatch => {
    try {
      const data = await queryCache.fetchQuery(['forms', uuid], () =>
        get({ uri: `/api/xm/1/forms/${uuid}` }),
      );
      dispatch(selectTriggerForm({ triggerFormId: data?.formId }));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error resolving form with uuid "${uuid}":`, error);
    }
  };
};

export function reset() {
  return {
    type: INIT_TRIGGER_FORM_RESET,
  };
}
